// extracted by mini-css-extract-plugin
export default {"inspiration":"Inspiration_inspiration__tInYP","inspo-video":"Inspiration_inspo-video__qET6t"};